/**
 * Zzzing Guest API
 * Zzzing Guest API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AirportTransferPrice { 
    price?: number;
    rate_id?: string;
    /**
     * The ID of the quotation that generated the price.  Quote this when booking to ensure same prices
     */
    provider_quotation_id?: string;
    /**
     * The vehicle type id
     */
    vehicle_type_id?: string;
}

